import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const benefits = [
  {
    title: "Competitive Edge",
    text: "Holding a commanding website with high-end functionalities under your kitty will definitely bring in a greater competitive edge for your school. We offer end-to-end web design services for your best school management system in India where your vision, attitude and your approach towards educating students gets reflected in the website which eventually yields you the required competitive advantage.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3 4 9v12h16V9l-8-6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M9 21v-6h6v6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Assured ROI",
    text: "Well, it has been a while since the academic industry got institutionalised which has now grown as one of the leading money making business through sculpting the future generation towards the glorified path. Investing in a website will certainly yield you assured ROI (Return Over Investment) and hence maximise your profit as well, and we are the best web design company in India in delivering profitable software for the school management system.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 18V6M4 18h16M8 14V11M12 14V8M16 14V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M16 10l3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Contacting Opportunities",
    text: "The parents will tend to prefer flexible options to establish communication with school management to attain further details before enrolling their child's admission. Having an interactive contact form or an accurate live chatbot will certainly do the needful. Being the most experienced website design company in Bangalore we offer engaging chatbot feature and convertible contact form for your website school management system in Bangalore.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-4 3v-3H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Striking Feedbacks",
    text: "A website is not just meant to be a marketing tool instead, it also acts as a perfect place to share and register parent's feedbacks which even helps educational institutions like schools to improvise their service offerings and sense the setbacks in their new range of services which helps them to undergo immediate rectification. We are the renowned website designing company in Bangalore India who help you deliver enriched educative service to students that eventually uplifts your growth.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5h16v14H4V5Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 9h8M8 12h6M8 15h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Effective Marketing",
    text: "Virtual communication is the driving force behind the success of any website and industries opt out to have a website to establish and maintain this communication mode. A website will be the centralised hub for a school management system where every online marketing activities get connected here. Holding a website helps you reach a number of parents and eventually builds trust amongst them. We are an innovative web designing company in Bangalore India who brings a complete set of functionalities for your school management system to help you deliver end-to-end information regarding your services to parents.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 7V5a4 4 0 1 1 8 0v2" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

const SmsWhyWebsite: React.FC = () => {
  return (
    <section className="sms-why" aria-labelledby="sms-why-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="sms-why-title" className="wdev-section-head__title wdev-section-head__title--dark">
            Why Schools Need a Website?
          </h2>
          <p className="sms-why__lead">
            In this digitally influenced environment, online presence has become the basic need for
            any business to hold its nerve and maintain sustainability. The same implies for the
            academic industry which requires an effectual website to keep itself updated and attain
            progressive growth. We are the promising web design company who creates a dedicated
            website for your entire best school management software in India with a complete set of
            enriched functionalities.
          </p>
        </AnimatedSection>

        <div className="sms-why__grid">
          {benefits.map((item, index) => (
            <motion.article
              key={item.title}
              className="sms-why-card"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              custom={index}
              variants={cardVariants}
            >
              <div className="sms-why-card__icon">{item.icon}</div>
              <h3 className="sms-why-card__title">{item.title}</h3>
              <p className="sms-why-card__text">{item.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SmsWhyWebsite;
